"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDefaultHttpClient = createDefaultHttpClient;
const nodeHttpClient_js_1 = require("./nodeHttpClient.js");
/**
 * Create the correct HttpClient for the current environment.
 */
function createDefaultHttpClient() {
    return (0, nodeHttpClient_js_1.createNodeHttpClient)();
}
//# sourceMappingURL=defaultHttpClient.js.map